import React from 'react';
import styled from 'styled-components';
import {StyledProps, mediaQueries} from '../../modules/common';
import {H1} from '../headings';

interface Props extends StyledProps {
    children: React.ReactNode;
}

const UnstyledCommonHeading = (props: Props): JSX.Element => {
    const {className, children} = props;
    return (
        <H1 $centered={false} className={className}>
            {children}
        </H1>
    );
};

/**
 * Heading for terms, privacy and about pages
 */
const CommonHeading = styled(UnstyledCommonHeading)`
    padding-top: 160px;
    margin: 0 0 32px;
    ${mediaQueries.lessThan('small')`
        padding-top: 104px;
    `};
`;

export const TeloaCommonHeading = styled(UnstyledCommonHeading)`
    padding-top: 160px;
    margin: 0 0 32px;
    ${mediaQueries.lessThan('small')`
        padding-top: 104px;
    `};
`;

export default CommonHeading;
